import { BrandForm } from '@/components'
import { ArrowLeft } from 'lucide-react'
import React from 'react'
import { Link } from 'react-router-dom'

const AddBrand = () => {
  return (
    <div className="h-screen flex items-start flex-col  pl-14 pt-12">
        <div className="group h-10 md:px-4 py-2 mb-6  ">
              <Link to="/seller" className=" text-sm font-medium ">
                <ArrowLeft className="group-hover:translate-x-[-5px] transition-transform duration-300 h-4 w-4 inline-block mr-2" />
                Back to Inventory
              </Link>
            </div>
    <BrandForm />
  </div>
  )
}

export default AddBrand
